import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { uuidPatternValidators } from 'src/app/utils/validator-patterns';

@Component({
  selector: 'app-ubereats-accounting-entries-file-exporter-configuration',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatIconModule,
    MatExpansionModule,
    MatFormFieldModule,
    MatInputModule
  ],
  templateUrl: './ubereats-ae-file-exporter-configuration.component.html',
  styleUrls: ['./ubereats-ae-file-exporter-configuration.component.scss']
})
export class UberEatsAccountingEntriesFileExporterConfigurationComponent {
  formGroup: FormGroup;

  constructor(
    readonly fb: FormBuilder

  ) {
    this.formGroup = fb.group({
      restaurantFilter: new FormControl(null, [Validators.pattern(uuidPatternValidators)]),
    });
  }
}